import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonAtcViewModel } from 'src/app/model/common/atc.view';
import { CommonMedicineViewModel } from 'src/app/model/common/medicine.view';

export interface CommonAtcState {
  result: VonPageResponseModel<CommonAtcViewModel>;
  plain: CommonAtcViewModel[];
  medicines: CommonMedicineViewModel[];
}

export const commonAtcIS: CommonAtcState = {
  result: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  },
  plain: [],
  medicines: [],
};
